import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <span className="brand-icon">📱</span>
            <span className="brand-text">Global SMS</span>
          </div>
          <p className="footer-text">© 2024 Global SMS. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
